import React, { useEffect, useState } from "react";

const ScrollToTop = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 300);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (!visible) return null;

  return (
    <button
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      style={{
        position: 'fixed',
        right: 20,
        bottom: 20,
        background: 'linear-gradient(135deg, #1F7D91, #E3704F)',
        color: '#FFFFFF',
        border: 'none',
        borderRadius: 999,
        padding: '10px 14px',
        boxShadow: '0 8px 24px rgba(31, 125, 145, 0.32)',
        zIndex: 1000,
        cursor: 'pointer',
        fontWeight: 700,
        fontFamily: 'inherit',
      }}
      aria-label="Scroll to top"
    >
      ↑
    </button>
  );
};

export default ScrollToTop;
